import React, { Component } from "react";

export class Footer extends Component {
  render() {
    return (
      <div className="foot" style={{ color: "white" }}>
        <a href="#">
          <i class="fab fa-facebook"></i>
        </a>{" "}
        |
        <a href="#">
          <i class="fab fa-instagram"></i>
        </a>{" "}
        |
        <a href="#">
          <i class="fab fa-twitter"></i>
        </a>{" "}
        |
        <a href="#">
          <i class="fab fa-linkedin"></i>
        </a>{" "}
        |
        <a href="#">
          <i class="fab fa-github"></i>
        </a>
      </div>
    );
  }
}

export default Footer;
